import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import { parseWords } from '../Utils';
import Game from './Game';
import FontKeys from '../FontKeys';
import ABCyaLib from '@abcya/abcya_lib';

const MAX_WORDS = 2000;

export default class InputScreen extends Phaser.Scene
{
    static get KEY() { return 'InputScreen'; }

    constructor()
    {
        super({ key: (InputScreen).KEY });
    }

    create()
    {
        this.background = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._input_background, this).setOrigin(0);

        // create the header
        this.add.rectangle(0,0,this.scale.width, 50, 0x2cbcdd).setOrigin(0);
        const txt = ABCyaPhaser.Text.addText(23,25,16, 0xffffff, FontKeys._BPreplayBold, ABCyaPhaser.Localization.instance.getLocalizedString("type_words_screen.header"), this, false).setOrigin(0, 0.5).setResolution(2);

        this.makeTextArea();

        this.goButton = this.add.container(this.scale.width, 0);
        const goBtnBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._create_button, this.goButton).setOrigin(1, 0);
        ABCyaPhaser.Container.setContainerInteractive(this.goButton);
        const goBtnTxt = ABCyaPhaser.Text.addText(-86,26,16, 0xffffff, FontKeys._BPreplayBold, ABCyaPhaser.Localization.instance.getLocalizedString("type_words_screen.create_button"), this.goButton, false).setResolution(2).setOrigin(1, 0.5);
        ABCyaPhaser.Buttons.convertToButton(this.goButton, {onClick:() => this.parseWords()});
    }

    makeTextArea()
    {
        this.textArea = document.createElement("textarea");
        this.textArea.setAttribute("id", "userInput");
        this.textArea.setAttribute("value", "");
        this.textArea.setAttribute("style", "width:518px; height:564px");

        this.textArea.style.fontSize = "32px";
        this.textArea.style.fontFamily = "Barlow";

        this.domTextArea = this.add.dom(1, 56, this.textArea).setOrigin(0);
        this.textArea.style.width = this.background.width - 6 + "px";
        this.textArea.style.height = this.background.height - 62 + "px";
        this.domTextArea.updateSize();
        this.textArea.addEventListener('input', () => {
            this.textArea.value = ABCyaLib.BadWordFilter.replaceBadWords(this.textArea.value);
        });

        this.textArea.style.resize = "none";
        this.textArea.style.overflow = "scroll";

        if (gameData.EDIT_SELECTED)
        {
            this.textArea.value = gameData.CURRENT_TEXT;
        }
        else
        {
            gameData.requestedFilteredWords = [];
        }
    }

    parseWords()
    {
        if (this.textArea == null)
        {
            return;
        }

        let string = this.textArea.value;

        if (string == '')
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._error, this);
            return;
        }

        this.goButton.setEnabled(false);

        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

        gameData.CURRENT_TEXT = string;

        let wordCount = parseWords(string);

        if (wordCount < MAX_WORDS)
        {
            this.scene.start(Game.KEY)
        }
        else
        {
            this.showMaximumWordsMessage();
        }
    }

    showMaximumWordsMessage()
    {
        this.domTextArea.setVisible(false);
        let message = this.add.container(this.scale.width/2, this.scale.height/2,
        [
          this.add.rectangle(0,0,this.scale.width, 62, 0xdcfdff),
          ABCyaPhaser.Text.addText(0,0,24, 0x2cbcdd, FontKeys._BPreplayBold, ABCyaPhaser.Localization.instance.getLocalizedString("type_words_screen.maximum_message"), this, true).setResolution(2),
        ]);

        ABCyaPhaser.Tweens.addTween(message, 500, { alpha: 0, delay: 2000 }, Phaser.Math.Easing.Linear, () => this.scene.start(Game.KEY));
    }
}